import EventTypeService from 'domains/models/event_type_service';
import Service from 'domains/models/service';
import ServicePrice from 'domains/models/service_price';
import TaxRate from 'domains/models/tax_rate';
import { schemaServicePriceItem } from '../service_price';
import ServiceRestrict from 'domains/models/service_restrict';
import {
  schemaServiceRestrictListItem,
  toListItem as toServiceRestrictListItem,
} from '../service_restrict';
import {
  schemaServiceRestrictSettingItem,
  toItem,
} from '../service_restrict_setting';
import ServiceRestrictSetting from 'domains/models/service_restrict_setting';
import { z } from 'zod';
import { schemaTaxRateItem } from '../tax_rate';

export type EventTypeServiceListItem = z.infer<
  typeof schemaEventTypeServiceListItem
>;
export const schemaEventTypeServiceListItem = z.object({
  uid: z.string().nullable(),
  serviceId: z.number().nullable(),
  sort: z.number(),
  isRequired: z.boolean(),
  isPaid: z.boolean(),
  isShowPrice: z.boolean(),
  name: z.string().nullable(),
  description: z.string().nullable(),
  caption: z.string().nullable(),
  coverImage: z.string().nullable(),
  price: schemaServicePriceItem.nullable(),
  taxRate: schemaTaxRateItem.nullable(),
  restrictSetting: schemaServiceRestrictSettingItem.nullable(),
  restricts: z.array(schemaServiceRestrictListItem),
});

export const toListItem = (
  eventTypeService: EventTypeService,
  service: Service,
  price: ServicePrice,
  taxRate: TaxRate,
  restrictSetting: ServiceRestrictSetting,
  restricts: ServiceRestrict[],
): EventTypeServiceListItem => {
  return {
    serviceId: service.id,
    uid: service.uid,
    sort: eventTypeService.sort,
    isRequired: eventTypeService.isRequired,
    isPaid: service.isPaid,
    isShowPrice: service.isShowPrice,
    name: service.name,
    description: service.description,
    caption: service.caption,
    coverImage: service.coverImage,
    price,
    taxRate,
    restrictSetting: toItem(restrictSetting),
    restricts: restricts.map((restrict: ServiceRestrict) => {
      return toServiceRestrictListItem(restrict);
    }),
  };
};
